import { render, staticRenderFns } from "./speedMainHome.vue?vue&type=template&id=38887c52&scoped=true&"
import script from "./speedMainHome.vue?vue&type=script&lang=js&"
export * from "./speedMainHome.vue?vue&type=script&lang=js&"
import style0 from "./speedMainHome.vue?vue&type=style&index=0&id=38887c52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38887c52",
  null
  
)

export default component.exports